import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getCar(c,id)
  {
    const url = apiUrl + 'Car/Get?id='+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

};

export default {
  namespaced: true,
  actions
}